import React from "react";
import {EditBudgetModal} from "../../../client/EditBudgetModal";
import {TYPE_ADGROUP, TYPE_BUSINESS_UNIT, TYPE_CAMPAIGN, TYPE_CAMPAIGNS_CONFIGURATION} from "../DashboardRow";
import {ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS, ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS} from "../../../business_units/BudgetTypes";
import {BudgetCellTooltip} from "./base/BudgetCellTooltip";
import {FaIcon} from "../../../FaIcon";
import {DashboardEditableCell} from "./base/DashboardEditableCell";

export class DashboardBudgetCell extends DashboardEditableCell {
    propForOnItemUpdated() {
        return this.props.onBudgetUpdated;
    }

    renderTooltip() {
        if(!this.hasPartialGoals())
            return null;

        return <BudgetCellTooltip
            periodType={this.props.periodType}
            partialGoals={this.props.budgetPartialGoals}
            totalBudget={this.props.value}
            formatedTotalBudget={this.props.formattedValue}
        />;
    }

    shouldRenderCellContent() {
        // Fila de un Bucc
        if(this.props.rowType === TYPE_CAMPAIGNS_CONFIGURATION)
            return false;

        // Fila de una campaña y presupuesto NO a nivel campaña
        if(this.props.rowType === TYPE_CAMPAIGN && this.props.budgetType !== ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS)
            return false;

        // Fila de un grupo de anuncios y presupuesto NO a nivel grupo de anuncios
        if(this.props.rowType === TYPE_ADGROUP && this.props.budgetType !== ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS)
            return false;

        return true;
    }

    hasPartialGoals() {
        return this.props.budgetPartialGoals && this.props.budgetPartialGoals.length > 0;
    }

    editionDisabled() {
        return this.props.rowType === TYPE_BUSINESS_UNIT && (this.props.budgetType === ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS || this.props.budgetType === ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS);
    }

    renderCellContent() {
        const itemsToRender = [];
        itemsToRender.push(this.renderWarningIfNecessary());
        if(!this.hasPartialGoals())
            itemsToRender.push(this.state.formattedValue);
        else
            itemsToRender.push(<span className={"has-toolbox"}>{this.state.formattedValue}&nbsp;&nbsp;&nbsp;<FaIcon iconName="list-ol"/></span>);
        return itemsToRender;
    }

    renderEditModal() {
        return <EditBudgetModal onFormSubmitted={this.handleItemModified}
                                businessUnitId={this.props.businessUnitId}
                                campaignsConfigurationId={this.props.campaignsConfigurationId}
                                campaignId={this.props.campaignId}
                                adgroupId={this.props.adgroupId}
                                value={this.props.value}
                                periodType={this.props.periodType}
                                fromDate={this.props.fromDate}
                                toDate={this.props.toDate}
                                budgetPartialGoals={this.props.budgetPartialGoals}
                                clickOutsideDontCloseModal={true}
                                clientName={this.props.clientName}
                                businessUnitName={this.props.businessUnitName}/>;
    }
}
